import React from "react";
import { Route, Switch } from "react-router-dom";

import NotFound from "../NotFound";
import Dashboard from "./Dashboard";
import Student from "./students/Student";
import Supplier from "./suppliers/Supplier";
import Staff from "./staffs/Staff";
import Parentfamily from "./parentfamilies/Parentfamily";
import Profiles from "./profiles/Profile";
import Section from "./sections/Section";
import StudentProfile from "./students/Profile";
import StudentProfilefile from "./students/Profilefile";
import StaffProfile from "./staffs/Profile";
import Establishment from "./establishments/Establishment";
import Year from "./years/Year";
import Trash from "./trashs/Trash";
import Archive from "./archives/Archive";
import Profile from "../users/Profile";
import Login from "../../partials/Login";
import Report from "./reports/Report";
import Remind from "./reminds/Remind";
import Search from "../users/Search";
import ArchiveDetail from "./archives/ArchiveDetail";
import Sectionclasse from "./sectionclasses/Sectionclasse";
import Leave from "./leaves/Leave";
import StudentIdentification from "./students/StudentIdentificationView";
import Affectation from "./students/Affectation";
import Presence from "./presences/Presence";

var permissions = JSON.parse(localStorage.getItem("permissions"))
function handleCheck(val) {
    return  (permissions ?? []).some(item => val === item.permission);
}


function RouterPage(){

    return(
        <Switch>

            {
                handleCheck("Afficher ressource humaine") == true && (
                    <Route exact path="/" component={Dashboard} />
                )
            }

            {
                handleCheck("Afficher élève") == true && (
                    <Route  path="/students/:studentId" component={StudentProfile} />
                )
            }

            {
                handleCheck("Afficher élève") == true && (
                    <Route  path="/identifications" component={StudentIdentification} />
                )
            }

            {
                handleCheck("Afficher élève") == true && (
                    <Route  path="/studentfile/:studentId" component={StudentProfilefile} />
                )
            }

            {
                handleCheck("Afficher bulletin") == true && (
                    <Route  path="/presences" component={Presence} />
                )
            }

            {
                handleCheck("Profil admin") == true && (
                    <Route  path="/reminds" component={Remind} />
                )
            }

            {
                handleCheck("Afficher élève") == true && (
                    <Route  path="/students" component={Student} />
                )
            }

            {
                handleCheck("Afficher affectation") == true && (
                    <Route path="/affectations" component={ Affectation } />
                )
            }

            {
                handleCheck("Afficher fournisseur") == true && (
                    <Route  path="/suppliers" component={Supplier} />
                )
            }

            {
                handleCheck("Afficher personnel") == true && (
                    <Route  path="/staffs/:staff_id" component={StaffProfile} />
                )
            }

            {
                handleCheck("Afficher personnel") == true && (
                    <Route  path="/staffs" component={Staff} />
                )
            }

            {
                handleCheck("Afficher parent") == true && (
                    <Route  path="/parentfamilies" component={Parentfamily} />
                )
            }

            {
                handleCheck("Afficher profil") == true && (
                    <Route  path="/profiles" component={Profiles} />
                )
            }

            {
                handleCheck("Afficher etablissement") == true && (
                    <Route  path="/establishments" component={Establishment} />
                )
            }

            {
                handleCheck("Afficher section") == true && (
                    <Route  path="/sections" component={Section} />
                )
            }

            {
                handleCheck("Afficher classe") == true && (
                    <Route  path="/classes" component={Sectionclasse} />
                )
            }

            {
                handleCheck("Afficher année") == true && (
                    <Route  path="/years" component={Year} />
                )
            }

            {
                handleCheck("Afficher congé") == true && (
                    <Route  path="/leaves" component={Leave} />
                )
            }

            {
                handleCheck("Afficher corbeille") == true && (
                    <Route  path="/trash" component={Trash} />
                )
            }

            {
                handleCheck("Afficher rapport") == true && (
                    <Route  path="/reports" component={Report} />
                )
            }

            {
                handleCheck("Afficher archive") == true && (
                    <Route  path="/archives/student/:year" component={ArchiveDetail} />
                )
            }

            {
                handleCheck("Afficher archive") == true && (
                    <Route  path="/archives" component={Archive} />
                )
            }
            
            <Route  path="/search/:search" component={ Search } />
            <Route  path="/profile" component={ Profile } />
            <Route  path="/get/:user_id" component={ Login } />
            <Route  path="/login" component={ Login } />
            
            <Route component={NotFound} />
        </Switch>
    )
}

export default RouterPage;
